import useApi from '@/hooks/useApi';
import { filterDataByType, isArray } from '@/lib/utils';

const { createContext, useContext, useEffect, useState } = require('react');

const UserSettingsContext = createContext();

export const useUserSettingsContext = () => {
  return useContext(UserSettingsContext);
};

export const UserSettingsProvider = ({ children }) => {
  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState('agent');
  const [filteredData, setFilteredData] = useState([]);
  const [isViewMode, setIsViewMode] = useState(false);
  const [selectedSetting, setSelectedSetting] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { makeApiCall } = useApi();

  const getOrderSettingsData = async () => {
    const response = await makeApiCall({
      url: 'agents',
      method: 'GET',
    });
    if (response?.status === 200) {
      setData(response.data.agents);
      updateData(response.data.agents);
    }
  };

  const filterData = (inputValue) => {
    const updatedData = data.filter((item) => {
      for (const key in item) {
        if (
          key !== '_id' &&
          item[key] &&
          item[key].toString().toLowerCase().includes(inputValue.toLowerCase())
        ) {
          return true;
        }
      }
      return false;
    });
    setFilteredData(updatedData);
  };

  const updateData = (data) => {
    const updatedData = filterDataByType(data, activeTab);
    setFilteredData(updatedData);
  };

  useEffect(() => {
    isArray(data) && updateData(data);
  }, [activeTab, data]);

  useEffect(() => {
    getOrderSettingsData();
  }, []);

  const value = {
    activeTab,
    isViewMode,
    filterData,
    isModalOpen,
    filteredData,
    setActiveTab,
    setIsViewMode,
    setIsModalOpen,
    selectedSetting,
    setSelectedSetting,
    getOrderSettingsData,
  };

  return (
    <UserSettingsContext.Provider value={value}>
      {children}
    </UserSettingsContext.Provider>
  );
};
